import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsFrenchSite } from '../../../store/navigation/navigation.selectors'
import Details from '../../genericComponents/Details'
import tooltipRight from '../../genericComponents/assets/tooltip-right.svg'
import logoMappy from '../../genericComponents/logo-mappy.svg'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import FooterContact from './FooterContact'
import s from './FooterInfos.less'
import SocialNetworkButtons from './SocialNetworkButtons'
import logoRatpEn from './logo-ratp-group-en.png'
import logoRatpFr from './logo-ratp-group-fr.png'
import logoRSS from './logo-ratp-ss.png'
import logoBonjour from './logo_bonjour.svg'

const FooterInfos = () => {
  const isFR = useSelector(selectIsFrenchSite)
  return (
    <Details
      summary={
        <span>
          <SVGIcon url={tooltipRight} className="ssrFooterImg" />
          <T id={'footer.infos'} />
        </span>
      }
      classes={[s.footerInfosHover]}
      toggleClasses={[s.chevron]}
    >
      <div className={s.content}>
        <div className={s.block}>
          <FooterContact />
        </div>
        {isFR && renderSocialNetworks()}
        {isFR && renderB2B()}
        {renderLanguagesWebsites()}
        {isFR ? renderFrenchContent() : renderInternationalContent()}
        {renderGroupLogos(isFR)}
      </div>
    </Details>
  )
}

const renderFrenchContent = () => {
  return (
    <>
      <div className={s.block}>
        <div className={s.title}>
          <T id={'footer.about.title'} />
        </div>
        <ul>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a target="_blank" href="https://blog.mappy.com/entreprise/" rel="nofollow noopener">
              <T id={'footer.link.about-us'} />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.welcometothejungle.com/fr/companies/ratp-smart-systems/jobs?page=1&aroundQuery=Paris%2C%20France&aroundLatLng=48.85718%2C2.34141&aroundRadius=20000"
              rel="nofollow noopener noreferrer"
            >
              Recrutement
            </a>
          </li>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a target="_blank" href="https://blog.mappy.com/" rel="noopener">
              Blog Mappy
            </a>
          </li>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a target="_blank" href="https://blog.mappy.com/categorie/espace-presse/" rel="nofollow noopener">
              Presse
            </a>
            {' | '}
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a target="_blank" href="https://blog.mappy.com/nos-partenaires/" rel="nofollow noopener">
              Partenaires
            </a>
          </li>
        </ul>
      </div>
      <div className={s.block}>
        <div className={s.title}>Vos questions</div>
        <ul>
          <li>
            {/* eslint-disable react/jsx-no-target-blank */}
            <a
              target="_blank"
              href="https://blog.mappy.com/entreprise/conditions-dutilisations/"
              rel="nofollow noopener"
            >
              <T id={'footer.link.terms-of-use'} />
            </a>
            {' | '}
            <a
              target="_blank"
              href="https://blog.mappy.com/entreprise/conditions-dutilisations/vie-privee/"
              rel="nofollow noopener"
            >
              Vie privée
            </a>
            {' | '}
            <a
              target="_blank"
              href="https://blog.mappy.com/entreprise/conditions-dutilisations/cookies/"
              rel="nofollow noopener"
            >
              <T id={'footer.link.cookies'} />
            </a>
            {/* eslint-enable react/jsx-no-target-blank */}
          </li>
          <li>
            <a target="_blank" href="https://mappy.uservoice.com/" rel="nofollow noopener noreferrer">
              FAQ - Nous contacter
            </a>
          </li>
          <li>
            {/* eslint-disable react/jsx-no-target-blank */}
            <a
              target="_blank"
              href="https://blog.mappy.com/les-transports-en-commun-sur-mappy/"
              rel="nofollow noopener"
            >
              Couverture transports en commun
            </a>
            {/* eslint-enable react/jsx-no-target-blank */}
          </li>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a target="_blank" href="https://blog.mappy.com/mappy-photographie-votre-ville/" rel="nofollow noopener">
              Mappy photographie votre ville
            </a>
          </li>
        </ul>
      </div>
    </>
  )
}
/* eslint-disable react/jsx-no-target-blank */

const renderInternationalContent = () => {
  return (
    <>
      <div className={s.block}>
        <div className={s.title}>
          <T id={'footer.about.title'} />
        </div>
        <ul>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a target="_blank" href="https://blog.mappy.com/entreprise/" rel="nofollow noopener">
              <T id={'footer.link.about-us'} />
            </a>
          </li>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              target="_blank"
              href="https://blog.mappy.com/entreprise/conditions-dutilisations/"
              rel="nofollow noopener"
            >
              <T id={'footer.link.terms-of-use'} />
            </a>{' '}
          </li>
          <li>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              target="_blank"
              href="https://blog.mappy.com/entreprise/conditions-dutilisations/cookies/"
              rel="nofollow noopener"
            >
              <T id={'footer.link.cookies'} />
            </a>
          </li>
          <li>
            <a target="_blank" href="https://mappy.uservoice.com/" rel="nofollow noopener noreferrer">
              <T id={'footer.link.contact'} />
            </a>
          </li>
        </ul>
      </div>
    </>
  )
}

const renderB2B = () => {
  return (
    <div>
      <div className={s.title}>Solutions</div>
      <ul>
        <li>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a target="_blank" href="https://blog.mappy.com/entreprise/nos-offres-commerciales/" rel="nofollow noopener">
            API
          </a>
        </li>
        <li>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a target="_blank" href="https://blog.mappy.com/entreprise/nos-produits/" rel="nofollow noopener">
            Mappy sur mobile
          </a>
        </li>
      </ul>
    </div>
  )
}

const renderGroupLogos = isFR => {
  return (
    <div className={s.LogoGroupe}>
      <a target="_blank" href="https://www.bonjour-ratp.fr/" rel="noreferrer noopener">
        <img src={logoBonjour} width="72" height="22" loading="lazy" alt="Bonjour RATP" />
      </a>
      <a className={s.LogoMappy} target="_blank" href="https://www.mappy.com/" rel="noreferrer noopener">
        <img src={logoMappy} width="66" height="15" loading="lazy" alt="Mappy" />
      </a>
      <a target="_blank" href="https://www.ratp.fr/groupe-ratp" rel="noreferrer noopener">
        <img
          src={isFR ? logoRatpFr : logoRatpEn}
          width="43"
          height="23"
          loading="lazy"
          alt={isFR ? 'Groupe RATP' : 'RATP Group'}
        />
      </a>
      <a target="_blank" href="https://www.ratpsmartsystems.com/" rel="noreferrer noopener">
        <img src={logoRSS} width="100" height="22" loading="lazy" alt="RATP Smart Systems" />
      </a>
    </div>
  )
}

const renderLanguagesWebsites = () => {
  return (
    <div className={s.block}>
      <div className={s.title}>
        <T id={'footer.sites.title'} />
      </div>
      <ul>
        <li>
          <a href="https://fr.mappy.com/">
            <span className={classNames(s.flag, s.France)} />
            France
          </a>
        </li>
        <li>
          <a href="https://fr-be.mappy.com/">
            <span className={classNames(s.flag, s.Belgium)} />
            Belgique (Français)
          </a>
        </li>
        <li>
          <a href="https://nl-be.mappy.com/">
            <span className={classNames(s.flag, s.Belgium)} />
            België (Nederlands)
          </a>
        </li>
        <li>
          <a href="https://en.mappy.com/">
            <span className={classNames(s.flag, s.UnitedKingdom)} />
            United Kingdom
          </a>
        </li>
      </ul>
    </div>
  )
}

const renderSocialNetworks = () => {
  return (
    <div className={s.block}>
      <div className={s.title}>Actualité</div>
      Retrouvez Mappy sur...
      <SocialNetworkButtons />
    </div>
  )
}

export default FooterInfos
